import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import { cualApp, rolGuardado } from "@/lib/arranque";
import ErrorBoundary from "@/components/ErrorBoundary";
import { instalarCaptura, reportar } from "@/lib/erroresFront";
import { MENSAJE as MENSAJE_DOM, instalarDomTolerante } from "@/lib/domTolerante";

// #116 (15-oct-2026): lo que no pasa por React (window.onerror, promesas rechazadas) también queda registrado.
instalarCaptura();
// #116 (16-oct-2026): el traductor de Chrome y algunas extensiones tocan el DOM por fuera de React; antes de dibujar
// nada, el DOM los tolera y el caso queda registrado (una vez por pestaña) en vez de dejar la pantalla en blanco.
instalarDomTolerante((que) => reportar(new Error(`${MENSAJE_DOM} (${que})`), null, { origen: "error" }));

// 9-oct-2026 — dos paquetes: la app del chofer (liviana) y la de la oficina (ver `lib/arranque.js`). Se decide acá,
// ANTES de cargar nada, y se trae uno solo. Para la oficina es la app de siempre, entera, en un paso más de carga.
const root = ReactDOM.createRoot(document.getElementById("root"));
const esChofer = cualApp({ ruta: window.location.pathname, rol: rolGuardado() }) === "chofer";
const traer = esChofer
  ? () => import(/* webpackChunkName: "app-chofer" */ "@/AppChofer")
  : () => import(/* webpackChunkName: "app-oficina" */ "@/App");

/** No se pudo traer el paquete (sin señal y sin copia guardada, o un corte a mitad de la carga): se dice y se ofrece
 * probar de nuevo. Sin esto quedaba la pantalla en blanco. */
function NoAbrio() {
  return (
    <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center",
      gap: 14, padding: 24, textAlign: "center", fontFamily: "system-ui, sans-serif", background: "#F4F5F7", color: "#1A1D23" }}
      data-testid="app-no-abrio">
      <div style={{ fontSize: 20, fontWeight: 700 }}>No se pudo abrir la app</div>
      <div style={{ fontSize: 15, color: "#6B7280", maxWidth: 300, lineHeight: 1.5 }}>
        Parece que no hay conexión. Probá de nuevo cuando tengas señal.
      </div>
      <button onClick={() => window.location.reload()}
        style={{ background: "#1B7A7A", color: "white", border: "none", borderRadius: 12, padding: "14px 24px", fontSize: 16, fontWeight: 700, cursor: "pointer" }}>
        Probar de nuevo
      </button>
    </div>
  );
}

traer()
  .then(({ default: App }) => {
    // #116: un error de render fuera del panel (el ingreso, un proveedor, la app del chofer) muestra un cartel en vez
    // del blanco y queda registrado. El del panel de oficina, por pantalla, vive en `AppLayout`.
    root.render(
      <React.StrictMode>
        <ErrorBoundary alcance="app">
          <App />
        </ErrorBoundary>
      </React.StrictMode>,
    );
  })
  .catch(() => root.render(<NoAbrio />));
